export const parseDateDDMMYYYY = (str) => {
  const [dia, mes, ano] = str.split('/');
  return new Date(Number(ano), Number(mes) - 1, Number(dia));
}

export const parseDateISO = (isoStr) => {
  const d = new Date(isoStr);
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

export const dataAtualDDMMYYYY = () => {
  const hoje = new Date()
  const dia = String(hoje.getDate()).padStart(2, '0')
  const mes = String(hoje.getMonth() + 1).padStart(2, '0')
  const ano = hoje.getFullYear()
  return `${dia}/${mes}/${ano}`
}

export const gerarVariaveisDeDias = (dataInicioStr) => {
  const [dia, mes, ano] = dataInicioStr.split('/');
  const dataAtual = new Date(ano, mes - 1, dia);
  const resultadoBotoes = {};

  for (let i = 1; i <= 4; i++) {
    dataAtual.setDate(dataAtual.getDate() + 1);
    const formatoDia = String(dataAtual.getDate()).padStart(2, '0');
    const formatoMes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const formatoAno = dataAtual.getFullYear();
    const chave = `datainicio_${String(i).padStart(2, '0')}`;
    resultadoBotoes[chave] = `${formatoDia}/${formatoMes}/${formatoAno}`;
  }

  return resultadoBotoes
}

export const filtrarAvisosPorData = (dataDDMMYYYY, rawData) => {
  if (!rawData || rawData.length === 0) return []
  const dataBotao = parseDateDDMMYYYY(dataDDMMYYYY)
  return rawData.filter(aviso => {
    const inicio = parseDateISO(aviso.data_inicio)
    const fim = parseDateISO(aviso.data_fim)
    return dataBotao >= inicio && dataBotao <= fim
  })
}

export const contarAvisosParaData = (dataDDMMYYYY, rawData) => {
  return filtrarAvisosPorData(dataDDMMYYYY, rawData).length
}
